import React from 'react'
import { generateFundDetailUrl } from '../../Helpers/FundUtility.js'
import {
  splitIntoGroupOfArrays,
  retrieveCusipAndClassLegacy,
} from './Helpers/FundViewerUtility.js'
import './MutualFundViewer.css'

function LegacyFundViewer({ productList, fund }) {
  function renderFunds() {
    const _productList = productList
      .reduce((prev, curr) => prev.concat(curr.funds), [])
      .sort((a, b) =>
        a.fundName > b.fundName ? 1 : a.fundName < b.fundName ? -1 : 0
      )

    const groupedArray = splitIntoGroupOfArrays(_productList, 3)

    return (
      <>
        {groupedArray.map((funds, i) => {
          return (
            <ul
              className="List"
              data-analytics="fund-viewer-links"
              key={'productList' + i}
            >
              {funds.map((_fund, i) => {
                const { cusip, fundClass } = retrieveCusipAndClassLegacy(
                  _fund,
                  fund.className
                )

                _fund.url = generateFundDetailUrl(
                  _fund,
                  fund.fundPath,
                  fundClass,
                  cusip
                )

                return (
                  <li className="List-item" key={_fund.fundName + i}>
                    <a className="Link u-textSecondary" href={_fund.url}>
                      {_fund.fundName}
                    </a>
                  </li>
                )
              })}
            </ul>
          )
        })}
      </>
    )
  }

  return (
    <div className="Grid">
      <div className="Grid Grid--alignTop Grid--fill Grid--flexMinSize1of3 Grid--withGutter u-size12of12 u-sm-sizeFull">
        {renderFunds()}
      </div>
    </div>
  )
}

export default LegacyFundViewer
